module.exports = __webpack_public_path__ + "static/media/agenda.7e1e7449.svg";